module.exports = {
          srcSet: __webpack_public_path__ + "35fba6b05139fdaa1e4bd663f7e08a65-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "35fba6b05139fdaa1e4bd663f7e08a65-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "35fba6b05139fdaa1e4bd663f7e08a65-801.png",
          toString:function(){return __webpack_public_path__ + "35fba6b05139fdaa1e4bd663f7e08a65-801.png"},
          
          width: 801,
          height: 566
        }